import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 30,
      refetchOnWindowFocus: false,
      retry: 1,
      placeholderData: (previousData: unknown) => previousData,
    },
  },
});

export const resetQueryClient = () => {
  queryClient.clear();
};
